export const notEmpty = (value: any) =>
  /^\s*$/i.test(value) || value == null ? 'Required' : null;
